<!-- Combination Building Details Print Section -->
<section class="combination-building-print">
  <!-- Title -->
  <div class="row_container ptitle">
    <div class="col-12">
      <h1><strong>{{ 'COMBINATION_BUILDING.TITLE' | translate }}</strong></h1>
    </div>
  </div>

  <!-- Main Content -->
  <div class="content" >
    <!-- Left Column: Functions -->
    <div class="left">
      <div class="row_container">
        <div class="col-12">
          <h2>{{ 'COMBINATION_BUILDING.FUNCTIONS_TITLE' | translate }}</h2>
        </div>
      </div>

      <div class="row_container">
        <div class="col-12">
          <div class="function-table">
            <div class="function-table-header">
              <div class="function-table-row header-row">
                <div class="function-table-cell header-cell" style="width:140px">{{ 'COMBINATION_BUILDING.FUNCTION_COLUMN' | translate }}</div>
                <div class="function-table-cell header-cell">{{ 'COMBINATION_BUILDING.UNITS_COLUMN' | translate }}</div>
                <div class="function-table-cell header-cell">{{ 'COMBINATION_BUILDING.GO_COLUMN' | translate }}</div>
                <div class="function-table-cell header-cell">{{ 'COMBINATION_BUILDING.GO_GEM_RUNTIME_COLUMN' | translate }}</div>
                <div class="function-table-cell header-cell">{{ 'COMBINATION_BUILDING.GO_TOTAL_COLUMN' | translate }}</div>
                <div class="function-table-cell header-cell">{{ 'COMBINATION_BUILDING.MPG_REQUIREMENT_COLUMN' | translate }}</div>
              </div>
            </div>

            <div class="function-table-body">
              <ng-container *ngFor="let item of details.functions">
                <div class="function-table-row">
                  <div class="function-table-cell" style="width: 140px; text-align: left;">{{ item.referenceNumber }}. {{ item.name }}</div>
                  <div class="function-table-cell" style="text-align: center;">{{ item.units }}</div>
                  <div class="function-table-cell">{{ item.go | number:'1.0-0' }} <span [innerHTML]="'BUILDING_FUNCTIONS.BVO_GBO_UNIT' | translate| fixDimensions "></span></div>
                    <div class="function-table-cell">{{ item.goGemRunTime | number:'1.0-0' }} <span [innerHTML]="'BUILDING_FUNCTIONS.BVO_GBO_UNIT' | translate| fixDimensions "></span></div>
                    <div class="function-table-cell">{{ item.goTotal | number:'1.0-0' }} <span [innerHTML]="'BUILDING_FUNCTIONS.BVO_GBO_UNIT' | translate| fixDimensions "></span></div>
                  <div class="function-table-cell">{{ item.mpgRequirement | number:'1.2-2' }}</div>
                </div>
              </ng-container>
            </div>

            <div class="function-table-footer">
              <div class="function-table-row footer-row">
                <div class="function-table-cell" style="grid-column: span 3; width: 250px;"></div>
                <div class="function-table-cell footer-cell total-label">{{ 'COMBINATION_BUILDING.TOTAL_LABEL' | translate }}</div>
                <div class="function-table-cell footer-cell">{{ totalGo | number:'1.0-0' }} <span [innerHTML]="'BUILDING_FUNCTIONS.BVO_GBO_UNIT' | translate| fixDimensions "></span></div>
                <div class="function-table-cell"></div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Column: Communal Areas (shown beside if functions > 17 rows) -->
    <div class="right" >
      <div class="row_container">
        <div class="col-12">
          <h2>{{ 'COMBINATION_BUILDING.COMMON_AREA_TITLE' | translate }}</h2>
        </div>
      </div>

      <div class="row_container">
        <div class="col-12">
          <div class="shared-table">
            <div class="shared-table-header">
              <div class="shared-table-row header-row">
                <div class="shared-table-cell header-cell">{{ 'COMBINATION_BUILDING.COMMON_AREA_NAME_COLUMN' | translate }}</div>
                <div class="shared-table-cell header-cell">{{ 'COMBINATION_BUILDING.GBO_AREA' | translate }}</div>
                <div class="shared-table-cell header-cell">{{ 'COMBINATION_BUILDING.ALLOCATION' | translate }}</div>
              </div>
            </div>

            <ng-container *ngIf="details.sharedSpaces.length; else noSharedSpaces">
              <div class="shared-table-body">
                <ng-container *ngFor="let space of details.sharedSpaces">
                  <div class="shared-table-row">
                    <div class="shared-table-cell">{{ space.name || '-' }}</div>
                    <div class="shared-table-cell">{{ space.gbo | number:'1.0-0' }} <span [innerHTML]="'BUILDING_FUNCTIONS.BVO_GBO_UNIT' | translate| fixDimensions "></span></div>
                    <div class="shared-table-cell">{{ space.allocation || '-' }}</div>
                  </div>
                </ng-container>
              </div>
            </ng-container>

            <ng-template #noSharedSpaces>
              <div class="shared-table-body">
                <div class="shared-table-row">
                  <div class="shared-table-cell">-</div>
                  <div class="shared-table-cell">-</div>
                  <div class="shared-table-cell">-</div>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>

      <div class="row_container">
        <div class="col-12">
          <h2 class="facade-title">{{ 'COMBINATION_BUILDING.FACADE_AREA' | translate }}</h2>
        </div>
      </div>

      <div class="row_container">
        <div class="col-12">
          <div class="facade-grid">
            <div class="facade-item facade-item-wide">
              <label>{{ 'COMBINATION_BUILDING.FACADE_AREA' | translate }}</label>
              <strong>{{ details.facadeSurface.surface | number:'1.0-0' }} <span [innerHTML]="'BUILDING_FUNCTIONS.BVO_GBO_UNIT' | translate| fixDimensions "></span></strong>
            </div>

            <div class="facade-item">
              <label>{{ 'COMBINATION_BUILDING.COMPACTNESS' | translate }}</label>
              <strong class="pill">{{ details.facadeSurface.compactness | number:'1.2-2' }}</strong>
            </div>

            <div class="facade-item">
              <label>{{ 'COMBINATION_BUILDING.MPG_AMBITIE' | translate }}</label>
              <strong>{{ details.facadeSurface.mpgAmbition | number:'1.2-2' }}</strong>
            </div>

            <div class="facade-item" *ngIf="isA2Visible">
              <label>{{ 'COMBINATION_BUILDING.MPG_EIS_A2' | translate }}</label>
              <strong class="pill">{{ getMpgLimitDisplayValue() != null ? (getMpgLimitDisplayValue() | number:'1.0-2':'nl') : '-' }}</strong>
            </div>

            <div class="facade-item" *ngIf="isA2Visible">
              <label>{{ 'COMBINATION_BUILDING.COR_FACTOR' | translate }}</label>
              <strong class="pill">{{ details.facadeSurface.correctionFactor | number:'1.2-2' }}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</section>